// src/use-is-hydrated.tsx
import { useSyncExternalStore } from "use-sync-external-store/shim";
function useIsHydrated() {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
}
function subscribe() {
  return () => {
  };
}
export {
  useIsHydrated
};
//# sourceMappingURL=index.mjs.map
